const arrayFormToHash = (arr) => {
  let h = {}
  arr.forEach( (v) => {
    h[v.fieldname] = v;
  });
  return h;
}

export default arrayFormToHash;